import React from 'react';
import { Header, RowData } from '@tanstack/table-core';
import { flexRender } from '@tanstack/react-table';

function TableFooter<TData extends RowData>({ footer }: { footer: Header<TData, unknown> }) {
  return <th key={footer.id}>{flexRender(footer.column.columnDef.footer, footer.getContext())}</th>;
}

export default TableFooter;
